export default "<div class=\"odsImageCropper\">\n  <img\n    ng-src=\"{{$ctrl.image}}\"\n    class=\"odsImageCropper_canvasContainer_canvas\"\n  />\n</div>\n";